<template lang="pug">
  .width-100
    content-list(type='drafts' ref='list')
    krea-create-in-team-modal(v-if='showCreateInTeamModal')
    krea-publish-content-modal(v-if='showKreaPublishContentModal' @success='reloadList')
    krea-edit-keywords-content-modal(v-if='showKreaEditKeywordsContentModal')
    krea-unpublish-content-modal(v-if='showKreaUnpublishContentModal' @success='reloadList')
</template>

<script>
import ContentList from '@/components/Krea/KreaContentList'
import { mapState } from 'vuex'
import KreaPublishContentModal from '@/components/Modals/KreaPublishContentModal'
import KreaUnpublishContentModal from '@/components/Modals/KreaUnpublishContentModal'
import KreaEditKeywordsContentModal from '@/components/Modals/KreaEditKeywordsContentModal'
import KreaCreateInTeamModal from '@/components/Modals/KreaCreateInTeamModal'

export default {
  components: {
    ContentList,
    KreaPublishContentModal,
    KreaUnpublishContentModal,
    KreaCreateInTeamModal,
    KreaEditKeywordsContentModal
  },
  computed: {
    ...mapState({
      showKreaPublishContentModal: state => state.behavior.kreaPublishContentModal.show,
      showKreaUnpublishContentModal: state => state.behavior.kreaUnpublishContentModal.show,
      showKreaEditKeywordsContentModal: state => state.behavior.kreaEditKeywordsContentModal.show,
      showCreateInTeamModal: state => state.behavior.kreaCreateInTeamModal.show
    }),
    toastStyles() {
      return {
        width: '100%',
        display: 'flex',
        left: '0',
        'justify-content': 'center'
      }
    }
  },
  methods: {
    reloadList() {
      this.$refs.list.reloadContent()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
